<template>
  <ucar-mask>
    <div class="video-upload">
      <div class="video-upload-close" @click="close"></div>
      <div class="video-upload-body">
        <h4>请脱帽，姿势端正、脸部无遮挡</h4>
        <img src="../assets/video-demo.png">
        <p class="big">读出“{{num}}”</p>
        <div class="tips-wrapper">
          <div class="tip-item angle">
            正对手机
          </div>
          <div class="tip-item light">
            光线充足
          </div>
          <div class="tip-item time">
            1-5秒内录完
          </div>
        </div>
      </div>
      <div class="video-upload-footer" @click="start">开始录制</div>
    </div> 
  </ucar-mask>  
</template>

<script>
export default {
  props: {
    num: {
      type: String,
      default: ''
    }
  },
  methods: {
    start () {
      this.$emit('upload')
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/variable.styl'
.video-upload {
  position: absolute;
  top: 136px;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  background-color: #fff;
  width: 690px;
  border-radius: 8px;

  .video-upload-close {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 36px;
    height: 36px;
    overflow: hidden;

    &::before, &::after {
      content: '';
      position: absolute;
      background-color: $ucar_light_border;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      width: 3px;
      height: 45px;
    }

    &::before {
      transform: translate3d(-50%, -50%, 0) rotate(45deg);
    }

    &::after {
      transform: translate3d(-50%, -50%, 0) rotate(-45deg);
    }
  }

  .video-upload-body {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    padding: 60px 0;

    h4 {
      text-align: center;
      font-size: $ucar_font_h3-h5;
      line-height: 1;
    }

    img {
      margin: 60px 0; 
      width: 480px;
      height: 344px;
    }

    .big {
      line-height: 1;
      font-size: $ucar_font_big;
      text-align: center;
    }

    .tips-wrapper {
      width: 100%;
      margin-top: 60px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .tip-item {
        box-sizing: border-box;
        padding-top: 110px;
        width: 190px;
        height: 164px;
        color: $ucar_font_color;
        text-align: center;
        font-size: $ucar_font_h6;

        &.angle {
          background: url('../assets/tip-angle.png') no-repeat 100%/100%;
        }

        &.light {
          background: url('../assets/tip-light.png') no-repeat 100%/100%;
        }

        &.time {
          background: url('../assets/tip-time.png') no-repeat 100%/100%;
        }
      }
    }
  }

  .video-upload-footer {
    border-top: 1PX solid $ucar_light_border; /*no*/
    height: 88px;
    line-height: 88px;
    text-align: center;
    font-size: $ucar_font_h4;
    color: $ucar_main_button;
  }
}
</style>